module.exports = __webpack_public_path__ + "img/analytics.215fcb56.svg";